import React from 'react';
import styled from 'styled-components';

import { colors } from '../constants';

export const SchumerLabel = styled.p`
  line-height: 2rem;
  display: flex;
  justify-content: space-between;
  margin: 1.5rem 0 0.25rem;
  color: ${colors.TEXT_PRIMARY};
`;
SchumerLabel.displayName = 'SchumerLabel';

export const SchumerDownloadLink = styled.a`
  box-sizing: border-box;
  color: ${colors.TEXT_ACTION};
  text-decoration: none;
  margin-right: 0.1875rem;
  &:hover {
    text-decoration: underline;
  }
  &:focus:not(:hover, :focus-visible) {
    text-decoration: none;
    outline: none;
    padding: auto;
  }
  &:focus-visible {
    text-decoration: none;
    outline: 0.125rem solid ${colors.UI_SECONDARY_ACCENT};
    border-radius: 0.125rem;
  }
  & > svg {
    margin-left: 0.5rem;
    path {
      stroke: ${colors.TEXT_ACTION};
    }
  }
`;
SchumerDownloadLink.displayName = 'SchumerDownloadLink';

export const SchumerBoxScroller = styled.div`
  height: 14.25rem;
  max-height: 14.25rem;
  min-height: 14.25rem;
  border: 0.0625rem solid #d8d8d8;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

export const SchumerBoxIframe = styled.iframe`
  height: 98%;
  width: 100%;
`;
SchumerBoxIframe.displayName = 'SchumerBoxIframe';

export const SchumerNotice = styled.p`
  margin: 2.5rem 0 0.5rem;
  line-height: 1.5rem;
  font-weight: 600;
  font-size: 0.9375rem;
  text-align: left;
  color: ${colors.TEXT_PRIMARY};
`;
SchumerNotice.displayName = 'SchumerNotice';

interface SchumerBoxContainerProps {
  src: string;
}

export const SchumerBoxContainer = ({ src }: SchumerBoxContainerProps) => (
  <SchumerBoxScroller>
    <SchumerBoxIframe title="Terms and Conditions" src={src} />
  </SchumerBoxScroller>
);
